import React, { useState } from "react";
import styles from "./AddScheduleItem.module.css";

import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import ToClose from "../../components/ToClose/ToClose";
import HeadingAndData from "../../components/HeadingAndData/HeadingAndData";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import CalendarInput from "../../components/CalendarInput/CalendarInput";


import { FaRegFileAlt } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

const AddScheduleItem = () => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    title: "",
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    type: "",
    staff: "",
    rooms: "",
    days: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    console.log("Form Data:", formData);
    // save logic goes here
  };

  const handleCancel = () => {
    setFormData({
      title: "",
      startDate: "",
      endDate: "",
      startTime: "",
      endTime: "",
      type: "",
      staff: "",
      rooms: "",
      days: "",
    });
    dispatch(closeModal());
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <HeadingAndIcon icon={<FaRegFileAlt />} heading="Add Schedule item" />
        <ToClose onClose={() => dispatch(closeModal())} />
      </div>

      <div className={styles.section}>
      <div className={styles.heading}>
        <HeadingAndIcon icon={<FaRegFileAlt />} heading="Schedule Details" />
</div>
        <div className={styles.content}>
          <div className={styles.formGrid}>
            <HeadingAndData
              label="Title"
              name="title"
              placeholder="Enter shift name"
              value={formData.title}
              onChange={handleChange}
              required
            />
            <CalendarInput
              fieldLabel="Start date"
              required
              value={formData.startDate}
              onChange={(val) =>
                setFormData((prev) => ({ ...prev, startDate: val }))
              }
            />
            <CalendarInput
              fieldLabel="End date"
              required
              value={formData.endDate}
              onChange={(val) =>
                setFormData((prev) => ({ ...prev, endDate: val }))
              }
            />

            <HeadingAndData
              label="Start Time"
              name="startTime"
              type="time"
              value={formData.startTime}
              onChange={handleChange}
              required
            />
            <HeadingAndData
              label="End Time"
              name="endTime"
              type="time"
              value={formData.endTime}
              onChange={handleChange}
              required
            />
            <HeadingAndDropDown
              label="Type"
              name="type"
              value={formData.type}
              onChange={handleChange}
              placeholder="Select Type"
              options={[
                { label: "Class", value: "class" },
                { label: "Meeting", value: "meeting" },
              ]}
              required
            />
            <HeadingAndDropDown
              label="Assign Staff"
              name="staff"
              value={formData.staff}
              onChange={handleChange}
              options={[
                { label: "John", value: "john" },
                { label: "Jane", value: "jane" },
              ]}
              placeholder="Select Staff"
              required
            />
            <HeadingAndDropDown
              label="Rooms"
              name="rooms"
              value={formData.rooms}
              onChange={handleChange}
              placeholder="Select Rooms"
              options={[
                { label: "Room A", value: "roomA" },
                { label: "Room B", value: "roomB" },
              ]}
              required
            />
          </div>
          <div>
            <HeadingAndDropDown
              label="Days"
              name="days"
              value={formData.days}
              placeholder="Select Days of Week"
              onChange={handleChange}
              options={[
                { label: "Monday", value: "Monday" },
                { label: "Tuesday", value: "Tuesday" },
                { label: "Wednesday", value: "Wednesday" },
                { label: "Thursday", value: "Thursday" },
                { label: "Friday", value: "Friday" },
              ]}
              required
            />
          </div>

          <div className={styles.actions}>
            <SaveAndCancel onCancel={handleCancel} onSave={handleSave} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddScheduleItem;
